import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs/internal/Observable";
import { of } from "rxjs/internal/observable/of";
import { catchError } from "rxjs/internal/operators/catchError";
import { tap } from "rxjs/internal/operators/tap";
import { AuthService } from "../services/auth.service";

@Injectable()
export class InvitationResolver {
  private router = inject(Router);
  private authService = inject(AuthService);

  emailToken: string = null;

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    // resolve the route and search for the token reference in the url
    this.emailToken = route.params["token"];

    // if token present
    if (this.emailToken) {
      // verify email
      return this.authService.getInvitationData(this.emailToken).pipe(
        tap((res) => res),
        catchError((err) => {
          return of(this.router.navigate(["/login"], { queryParams: { verify: false } }));
        }),
      );
    }
  }
}
